// Generated by GitHub Copilot
import React from "react";
import { Row, Col } from "react-bootstrap";
import styles from "./BrandGrid.module.css";

function BrandGrid({ brandData, onBrandClick, selectedBrand }) {
  if (!brandData) {
    return (
      <div className={styles.emptyState}>
        <p>No brand data available</p>
      </div>
    );
  }

  const brands = Object.keys(brandData).map((brandName) => ({
    name: brandName,
    ...brandData[brandName],
  }));

  // Generated by GitHub Copilot - Filter to show only selected brand if one is selected
  const visibleBrands = selectedBrand
    ? brands.filter((brand) => brand.name === selectedBrand)
    : brands;

  return (
    <Row className="g-2">
      {visibleBrands.map((brand, index) => {
        const isSelected = selectedBrand === brand.name;
        return (
          <Col
            key={index}
            xs={12}
            sm={6}
            md={8}
            lg={6}
            onClick={() => onBrandClick && onBrandClick(brand.name)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onBrandClick && onBrandClick(brand.name);
              }
            }}
          >
            <div
              className={`${styles.card} ${
                isSelected ? styles.cardSelected : ""
              }`}
            >
              <div className={styles.cardHeader}>
                <h4 className={styles.brandName}>{brand.name}</h4>
              </div>

              {/* Generated by GitHub Copilot - US1812367: Updated to Active/Resolved statuses */}
              <div className={styles.statusBoxes}>
                <div className={styles.statusBox}>
                  <div
                    className={`${styles.statusIndicator} ${styles.statusRed}`}
                  />
                  <div className={styles.statusLabel}>Active</div>
                  <div className={styles.statusValue}>{brand.active || 0}</div>
                </div>

                <div className={styles.statusBox}>
                  <div
                    className={`${styles.statusIndicator} ${styles.statusGreen}`}
                  />
                  <div className={styles.statusLabel}>Resolved</div>
                  <div className={styles.statusValue}>
                    {brand.resolved || 0}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        );
      })}
    </Row>
  );
}

export default BrandGrid;
